<template>
  <div>
    <div
      :class="[
        'md-collapse',
        activeCollapse(index + 1),
        { [getColorCollapse(colorCollapse)]: true },
      ]"
      v-for="(item, index) in collapse"
      :key="item"
    >
      <div class="md-collapse-label" @click="toggle(index + 1)">
        <h5
          class="md-collapse-title"
          :style="titleStyle"
        >
          {{ item }}
          <md-icon>{{ icon }}</md-icon>
        </h5>
      </div>

      <collapse-transition>
        <div class="md-collapse-content" :style="{ padding: containerPadding }" v-show="getActiveCollapse(index + 1)">
          <slot :name="getCollapseContent(index + 1)"></slot>
        </div>
      </collapse-transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'collapse',
  props: {
    collapse: Array,
    titleStyle: {
      type: Object,
      default: () => ({})
    },
    containerPadding: {
      type: String,
      default: ''
    },
    icon: String,
    colorCollapse: String
  },
  data () {
    return {
      activePanels: []
    }
  },
  methods: {
    getActiveCollapse (index) {
      let isActive = false
      this.activePanels.map(activeItem => {
        if (activeItem === index) {
          isActive = true
        }
      })
      return isActive
    },
    activeCollapse (index) {
      return {
        'is-active': this.getActiveCollapse(index)
      }
    },
    toggle (index) {
      let wasActive = false
      this.activePanels.forEach((activeItem, i) => {
        if (activeItem === index) {
          this.activePanels.splice(i, 1)
          wasActive = true
        }
      })
      if (!wasActive) {
        this.activePanels.push(index)
      }
      // if (index === this.activePanels) {
      //   this.activePanels = 0
      // } else {
      //   this.activePanels = index
      // }
    },
    getCollapseContent: function (index) {
      return 'md-collapse-pane-' + index + ''
    },
    getColorCollapse: function (colorCollapse) {
      return 'md-' + colorCollapse + ''
    }
  }
}
</script>

<style lang="scss" scoped>
.text-center {
  display: flex;
}
</style>
